<template>
  <div class="d-flex align-center">
    <SysRelatoriosCompra
      v-model="relatorio_selecionado"
      return-object
      outlined
      :pedido_compra="pedido_selecionado"
      :produtos_pedido_selecionado="produtos_pedido_selecionado"
      style="width: 100%"
      dark
      dense
      hide-details
      auto_select_relatorio_pdf
      :click_botao_gerar_count="click_botao_gerar_count"
      @sankhya:pedido-exportado="atualizarPedidosCompra()"
      @ciss-poder-integrim:pedido-exportado="atualizarPedidosCompra()"
      @gemco:pedido-exportado="atualizarPedidosCompra()"
      @citel:pedido-exportado="atualizarPedidosCompra()"
      @nerus:pedido-exportado="atualizarPedidosCompra()"
      @dunorte:pedido-exportado="atualizarPedidosCompra()"
      @casa-tudo-sacolao:pedido-exportado="atualizarPedidosCompra()"
      @nativa-winthor:pedido-exportado="atualizarPedidosCompra()"
      @padre-cicero:pedido-exportado="atualizarPedidosCompra()"
      @api-pedidos-systock:pedido-exportado="atualizarPedidosCompra()"
      @consinco:pedido-exportado="atualizarPedidosCompra()"
    />

    <v-layout>
      <cotacao-v2-apos-relatorio
        v-model="dialog_cotacao"
        :pedido="pedido_selecionado"
        :produtos_pedido="produtos_pedido_selecionado"
        @update:modelValue="atualizarPedidosCompra()"
        @cotacaoAposRelatorio="eventCotacaoAposRelatorio($event)"
      />
    </v-layout>

    <v-btn color="success" class="ml-3" @click="abrirCotacaoV2()">
      Gerar
    </v-btn>

    <ExportacaoConsolidada
      v-model="exportacao_consolidada_ativo"
      @nao="executarRelatoriosPadraoSystock(false)"
      @sim="executarRelatoriosPadraoSystock(true)"
    />
  </div>
</template>

<script>
import SysRelatoriosCompra from "@/components/utils/crud/SysRelatoriosCompra";
import $axios from '@/api/api.js';
import { mapGetters } from "vuex";
import ExportacaoConsolidada from "@/components/compra/ProdutosGerais/Carrinho/ExportacaoConsolidada.vue";
import CotacaoV2AposRelatorio from "@/components/compra/carrinho/dialogs/CotacaoV2AposRelatorio/Index.vue";

export default {
  name: "RelatoriosCarrinho",
  components: {
    CotacaoV2AposRelatorio,
    SysRelatoriosCompra,
    ExportacaoConsolidada,
  },
  props: {
    pedido_selecionado: Object,
    produtos_pedido_selecionado: Array,
    pedidos: Array,
  },
  data: () => ({
    fornecedor_selecionado: '',
    relatorio_selecionado: {},
    click_botao_gerar_count: 0,
    exportacao_consolidada_ativo: false,
    dialog_cotacao: false,
  }),
  computed: {
    CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO() {
      return this.$store.getters["CompraProdutosGerais/callbackRecarregarPedidosCompraCarrinho"]
    },
    ...mapGetters({
      FILTROS_STORE: "CompraProdutosGerais/getFiltros",
    }),
    ID_FORNECEDOR_COMPUTED() {
      const idPedido = this.pedido_selecionado && this.pedido_selecionado.idfornecedor
        ? this.pedido_selecionado.idfornecedor
        : null;
      const idFiltro = !idPedido && this.FILTROS_STORE && this.FILTROS_STORE.idfornecedor
        ? this.FILTROS_STORE.idfornecedor
        : null;
      return idPedido || idFiltro || null;
    },
    URL_RELATORIO_SELECIONADO_COMPUTED() {
      const base = $axios.defaults.baseURL || "";
      const src = (this.relatorio_selecionado && this.relatorio_selecionado.src_aplicativo) || "";

      const idsPedidos = (this.pedidos || []).map(function (item) { return item.idpedido; }).join();
      const filtros = encodeURIComponent(JSON.stringify(this.FILTROS_STORE || {}));
      let parametros =
        "pedido=" + this.pedido_selecionado.idpedido +
        "&grupo=" + this.pedido_selecionado.grupo +
        "&usuario=" + localStorage.getItem("nome") +
        "&id_usuario=" + localStorage.getItem("id") +
        "&systock=grupo" +
        "&ids_pedidos=" + idsPedidos +
        "&filtros_gerais=" + filtros;

      if (this.RELATORIO_SELECIONADO_EH_PADRAO_SYSTOCK_COMPUTED && this.ID_FORNECEDOR_COMPUTED) {
        parametros += "&idfornecedor_exportacao=" + this.fornecedor_selecionado;
      }

      return base + "/" + src + "?" + parametros;
    },
    RELATORIO_SELECIONADO_EH_PADRAO_SYSTOCK_COMPUTED() {
      const relatorios_systock = [
        'relatorio_pedido_excel_cotacao',
        'relatorio_pedido_compra_pdf_cotacao',
        'relatorio_pedido_excel',
        'relatorio_pedido_compra_pdf',
        'relatorio_pedido_compra_pdf/lojas-2001',
        'relatorio_pedido_compra_pdf/ep-eletrica',
      ];
      const src = (this.relatorio_selecionado && this.relatorio_selecionado.src_aplicativo) || "";
      return relatorios_systock.indexOf(src) !== -1;
    }
  },
  methods: {
    abrirCotacaoV2() {
      if (this.RELATORIO_SELECIONADO_EH_PADRAO_SYSTOCK_COMPUTED) {
        const fornecedores_unicos = [
          ...new Set(this.produtos_pedido_selecionado.map(p => p.idfornecedor_do_produto))
        ];

        if (fornecedores_unicos.length > 1) {
          this.dialog_cotacao = true;
        } else {
          this.fornecedor_selecionado = fornecedores_unicos[0];
          this.verificarConsolidacaoPedidosNoRelatorio();
        }
      }

      this.click_botao_gerar_count++;
    },
    gerarRelatorio() {
      if (this.RELATORIO_SELECIONADO_EH_PADRAO_SYSTOCK_COMPUTED) {
        this.verificarConsolidacaoPedidosNoRelatorio();
        return;
      }
      if (this.relatorio_selecionado && this.relatorio_selecionado.relatorio_com_exportacao_personalizada) return;

      const ignorar_relatorio_tateti = this.relatorio_selecionado.src_aplicativo === 'relatorios/pedido-compra/tateti';

      if (!(this.pedido_selecionado.idpedido > 0) || !this.relatorio_selecionado.src_aplicativo || ignorar_relatorio_tateti) {
        return;
      }

      window.open(this.URL_RELATORIO_SELECIONADO_COMPUTED, "_blank");
    },
    atualizarPedidosCompra() {
      this.CALLBACK_ATUALIZAR_PEDIDOS_CARRINHO();
    },
    verificarConsolidacaoPedidosNoRelatorio() {
      const filialOk = Number(this.pedido_selecionado.filial) > 0;
      const consolidacaoAtiva = localStorage.compras_carrinho_ativar_consolidacao_pedidos_em_relatorios === 'S';
      if (filialOk && consolidacaoAtiva) {
        this.exportacao_consolidada_ativo = true;
      } else {
        this.executarRelatoriosPadraoSystock();
      }
    },
    executarRelatoriosPadraoSystock(consolidar_exportacao = false) {
      this.dialog_cotacao = false;
      window.open(this.URL_RELATORIO_SELECIONADO_COMPUTED + "&consolidar_exportacao=" + (consolidar_exportacao ? 'S' : 'N'), "_blank");
    },
    eventCotacaoAposRelatorio(evento) {
      this.fornecedor_selecionado = evento;

      this.gerarRelatorio();
    }
  }
}
</script>

<style scoped>
</style>
